import { apiService } from "../api";

export interface CmsSettings {
  id: string;
  facebookUrl: string | null;
  instagramUrl: string | null;
  twitterUrl: string | null;
  youtubeUrl: string | null;
  whatsappNumber: string | null;
  email: string | null;
  storeLocation: string | null;
  homePageImage: string | null;
  homePageTitle: string | null;
  homePageDescription: string | null;
  homePageSubtitle: string | null;
  facebookPixelId: string | null;
  googleAnalyticsId: string | null;
  siteName: string | null;
  siteDescription: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateCmsSettingsRequest {
  facebookUrl?: string | null;
  instagramUrl?: string | null;
  twitterUrl?: string | null;
  youtubeUrl?: string | null;
  whatsappNumber?: string | null;
  email?: string | null;
  storeLocation?: string | null;
  homePageImage?: string | null;
  homePageTitle?: string | null;
  homePageDescription?: string | null;
  homePageSubtitle?: string | null;
  facebookPixelId?: string | null;
  googleAnalyticsId?: string | null;
  siteName?: string | null;
  siteDescription?: string | null;
}

export const adminCmsService = {
  getSettings: async (): Promise<CmsSettings> => {
    return await apiService.get<CmsSettings>("/admin/cms");
  },

  updateSettings: async (
    data: UpdateCmsSettingsRequest
  ): Promise<CmsSettings> => {
    return await apiService.put<CmsSettings>("/admin/cms", data);
  },

  getFacebookPixelId: async (): Promise<string | null> => {
    const response = await apiService.get<{ pixelId: string | null }>(
      "/admin/cms/facebook-pixel-id"
    );
    return response.pixelId;
  },
};
